const useQuery = (search: string) => {
  return new URLSearchParams(search);
}

export default useQuery;
